var map = {
	"./STEM-Based-Training/cansat-launch-system.jpg": 6528,
	"./STEM-Based-Training/satellite-hardware-training.jpg": 8709,
	"./belt-road-maker-camp-2021/01.jpg": 9972,
	"./belt-road-maker-camp-2021/02.jpg": 8099,
	"./belt-road-maker-camp-2021/03.jpg": 9574,
	"./cadet-college-hasanabdal-2023/01.jpg": 92,
	"./cadet-college-hasanabdal-2023/02.jpg": 7067,
	"./cadet-college-hasanabdal-2023/03.jpg": 5758,
	"./cansat-lab-model-2023/01.jpg": 1287,
	"./cansat-lab-model-2023/02.jpg": 8712,
	"./cansat-lab-model-2023/03.jpg": 9621,
	"./cansat-webinar-2024/01.jpg": 2309,
	"./cansat-webinar-2024/02.jpg": 1322,
	"./cansat-webinar-2024/03.jpg": 3975,
	"./eighth-space-summer-school-2024/01.jpg": 2243,
	"./eighth-space-summer-school-2024/02.jpg": 2196,
	"./eighth-space-summer-school-2024/03.jpg": 241,
	"./internship-2022/01.jpg": 6678,
	"./lets-build-a-cansat-2023/01.jpg": 1085,
	"./lets-build-a-cansat-2023/02.jpg": 8946,
	"./lets-build-a-cansat-2023/03.jpg": 8943,
	"./national-cansat-competition-2024/01.jpg": 3661,
	"./national-cansat-competition-2024/02.jpg": 4434,
	"./national-cansat-competition-2024/03.jpg": 6143,
	"./ninth-space-summer-school-2025/01.jpg": 4616,
	"./ninth-space-summer-school-2025/02.jpg": 4599,
	"./ninth-space-summer-school-2025/03.jpg": 3210,
	"./nust-space-engineering-2024/01.jpg": 1143,
	"./nust-space-engineering-2024/02.jpg": 1160,
	"./nust-space-engineering-2024/03.jpg": 5477,
	"./pakistan-learning-festival-2024/01.jpg": 1035,
	"./pakistan-learning-festival-2024/02.jpg": 8236,
	"./pakistan-learning-festival-2024/03.jpg": 6281,
	"./quality-circles-2022/01.jpg": 443,
	"./quality-circles-2022/02.jpg": 2748,
	"./quality-circles-2022/03.jpg": 6473,
	"./sciventure-2025/01.jpg": 5581,
	"./sciventure-2025/02.jpg": 1426,
	"./sciventure-2025/03.jpg": 7807,
	"./space-careers-seminar-2024/01.jpg": 856,
	"./space-careers-seminar-2024/02.jpg": 1431,
	"./space-careers-seminar-2024/03.jpg": 618,
	"./space-expo-2024/01.jpg": 313,
	"./space-expo-2024/02.jpg": 254,
	"./space-expo-2024/03.jpg": 1387,
	"./space-maker-camp-2023/01.jpg": 4666,
	"./space-maker-camp-2023/02.jpg": 8805,
	"./space-maker-camp-2023/03.jpg": 7624,
	"./steam-mela-2024/01.jpg": 4324,
	"./steam-mela-2024/02.jpg": 8483,
	"./steam-mela-2024/03.jpg": 2022,
	"./steam-summer-camp-2022/01.jpg": 4600,
	"./steam-summer-camp-2022/02.jpg": 3527,
	"./steam-summer-camp-2022/03.jpg": 4522,
	"./stem-olympiad-2024/01.jpg": 5595,
	"./stem-olympiad-2024/02.jpg": 9148,
	"./stem-olympiad-2024/03.jpg": 841,
	"./underserved-communities-2025/01.jpg": 7108,
	"./underserved-communities-2025/02.jpg": 3331,
	"./underserved-communities-2025/03.jpg": 6185,
	"./women-in-space-2023/01.jpg": 5804,
	"./women-in-space-2023/02.jpg": 8603,
	"./women-in-space-2023/03.jpg": 766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6032;